import { NgModule } from '@angular/core';
import { CuentaComponent } from './cuenta.component';
import { CuentasRouting } from './cuenta-routing';
import { MaterialModule } from 'app/material.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { PerfilComponent } from './perfil/perfil.component';
import { AccountComponent } from './perfil/account/account.component';
import { UploadFilesComponent } from 'app/utilerias/upload-files/upload-files.component';
import { SettingsPlaceComponent } from './perfil/place/place.component';
import { AccountSeriesComponent } from './perfil/place/series/series.component';
import { SettingsObservationsComponent } from './perfil/observations/observations.component';
import { SettingsBankAccountComponent } from './perfil/bank-account/bank-account.component';
import { DialogNewObservationComponent } from './perfil/observations/dialog-new-observation/dialog-new-observation.component';
import { DialogNewBankAccountComponent } from './perfil/bank-account/dialog-new-bank-account/dialog-new-bank-account.component';
import { SettingsTeamComponent } from './perfil/team/team.component';
import { DialogNewMemberComponent } from './perfil/team/dialog-new-member/dialog-new-member.component';
import { SettingsSecurityComponent } from './perfil/security/security.component';
import { SettingsFoliosComponent } from './perfil/folios/folios.component';
import { DialogNewPlaceComponent } from './perfil/place/dialog-new-place/dialog-new-place.component';
import { BuyFoliosComponent } from './perfil/folios/buy-folios/buy-folios.component';
import { FuseCardModule } from '@fuse/components/card/card.module';
import { FuseAlertModule } from '@fuse/components/alert/alert.module';
import { DigitalStampComponent } from './perfil/digital-stamp/digital-stamp.component';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { CompanyFielComponent } from './perfil/company-fiel/company-fiel.component';
import { FuseAlertComponent } from '@fuse/components/alert';
import { NoCompanyFoundComponent } from './no-company-found/no-company-found.component';
import { WizzardCompanyComponent } from './wizzard-company/wizzard-company.component';
import { WizFacturacionComponent } from './wizzard-company/wiz-facturacion/wiz-facturacion.component';
import { WizSellosComponent } from './wizzard-company/wiz-sellos/wiz-sellos.component';
import { WizExpedicionComponent } from './wizzard-company/wiz-expedicion/wiz-expedicion.component';
import { WizDoneComponent } from './wizzard-company/wiz-done/wiz-done.component';
import { NewCompanyComponent } from './new-company/new-company.component';

@NgModule({
  declarations: [
    CuentaComponent,
    PerfilComponent,
    AccountComponent,
    UploadFilesComponent,
    SettingsPlaceComponent,
    AccountSeriesComponent,
    SettingsObservationsComponent,
    SettingsBankAccountComponent,
    DialogNewObservationComponent,
    DialogNewBankAccountComponent,
    SettingsTeamComponent,
    DialogNewMemberComponent,
    SettingsSecurityComponent,
    SettingsFoliosComponent,
    DialogNewPlaceComponent,
    BuyFoliosComponent,
    DigitalStampComponent,
    CompanyFielComponent,
    NoCompanyFoundComponent,
    WizzardCompanyComponent,
    WizFacturacionComponent,
    WizSellosComponent,
    WizExpedicionComponent,
    WizDoneComponent,
    NewCompanyComponent
  ],
  imports: [
    CommonModule,
    CuentasRouting,
    MaterialModule,
    SharedModule,
    FuseCardModule,
    FuseAlertModule,
    GuidedTourModule,
    FuseAlertComponent
      // CurrencyMaskModule
  ],
  providers: [
    GuidedTourService
  ]
})
export class CuentasModule { }